<template>
  <div>
    <b-row fluid class="mx-0 mb-2 mb-sm-3 justify-content-end">
      <b-button type="button" variant="primary" id="traRefresh" @click="getTraData()" class="mx-0">
        <Icon type="f" /> {{ $t('btn.f') }}
      </b-button>
    </b-row>
    <TransTable v-if="isUser" ref="table1" suffix="traTabPreU"
        :query="traTabDefU"
        showShow showReject showSubmit showPagination
        :noHitText="$t('tra.tno')" />
    <TransTable v-if="!isUser" ref="table2" suffix="traTabPreC"
        :query="traTabDefC"
        showShow showCancel showPagination
        :noHitText="$t('tra.tno')" />
  </div>
</template>

<script>
import Icon from '@/components/Icon';
import TransTable from '@/components/transactions/TransTable';

export default {
  data() {
    return {
      traTabDefU: { q: 'createdAt:l:{T-1},senderUuid4::{U}', p: '10' },
      traTabDefC: { q: 'createdAt:l:{T},senderUuid4:n:{B},receiverUuid4::{U}', p: '20' },
    }
  },
  computed: {
    isUser() {
      return this.$store.state.oLogin.isUser;
    },
  },
  methods: {
    getTraData() {
      if (this.isUser) {
        this.$refs['table1'].getTraData();
      } else {
        this.$refs['table2'].getTraData();
      }
    },
  },
  components: {
    TransTable,
    Icon,
  },
}
</script>
